// extracted by mini-css-extract-plugin
module.exports = {"qt-loading-animation":"loadingIcon-m__qt-loading-animation__3xGZP"};